import { render, staticRenderFns } from "./UploadFileContract2022.vue?vue&type=template&id=09ba9b44&scoped=true"
import script from "./UploadFileContract2022.vue?vue&type=script&lang=js"
export * from "./UploadFileContract2022.vue?vue&type=script&lang=js"
import style0 from "./UploadFileContract2022.vue?vue&type=style&index=0&id=09ba9b44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ba9b44",
  null
  
)

export default component.exports